export default __webpack_public_path__ + "static/media/product_6.4f7b884e.webp";